import { connect } from 'react-redux';
import Login from '../components/Login';
import { thunks } from '../actions';

const mapStateToProps = (state, ownProps) => {

  return {
    authenticate: state.authenticate,
    loginError: state.loginError,
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    login: (username, password) => {
      dispatch(thunks.login(username, password));
    },
  };
};

const LoginContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);

export default LoginContainer;
